<template>
  <div>
    <base-struct></base-struct>
  </div>
</template>

<script>

import BaseStruct from './components/BaseStruct.vue';

export default {
	components: {
		BaseStruct,
	},
  created () {
      document.title = "WebTEC2";
      const descEl = document.querySelector('head meta[name="viewport"]');
      descEl.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0');
  }
};
</script>
